<template>
  <div
    class="image-placeholder"
    :class="[`ratio-${ratio.replace(':', '-')}`, variant]"
    role="img"
    :aria-label="keyword"
  >
    <span class="placeholder-label">{{ label }}</span>
    <span class="placeholder-keyword">{{ keyword }}</span>
  </div>
</template>

<script>
export default {
  name: 'ImagePlaceholder',
  props: {
    keyword: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: 'Image placeholder'
    },
    ratio: {
      type: String,
      default: '4:3'
    },
    variant: {
      type: String,
      default: 'default'
    }
  }
}
</script>

<style lang="scss" scoped>
.image-placeholder {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 24px;
  border-radius: 12px;
  border: 1px dashed rgba(15, 76, 129, 0.35);
  background:
    linear-gradient(145deg, rgba(15, 76, 129, 0.08) 0%, rgba(26, 127, 176, 0.14) 100%),
    repeating-linear-gradient(
      -45deg,
      rgba(255, 255, 255, 0.35) 0,
      rgba(255, 255, 255, 0.35) 8px,
      rgba(15, 76, 129, 0.04) 8px,
      rgba(15, 76, 129, 0.04) 16px
    );
  text-align: center;
  overflow: hidden;

  &.ratio-16-9 {
    aspect-ratio: 16 / 9;
  }

  &.ratio-4-3 {
    aspect-ratio: 4 / 3;
  }

  &.ratio-3-2 {
    aspect-ratio: 3 / 2;
  }

  &.hero {
    height: 100%;
    min-height: 100%;
    aspect-ratio: auto;
    border: none;
    border-radius: 0;
    background:
      linear-gradient(120deg, rgba(8, 42, 72, 0.92) 0%, rgba(15, 76, 129, 0.78) 45%, rgba(26, 127, 176, 0.65) 100%),
      repeating-linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.04) 0,
        rgba(255, 255, 255, 0.04) 12px,
        transparent 12px,
        transparent 24px
      );
  }
}

.placeholder-label {
  font-size: 11px;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.72);
  font-family: 'Aileron-Regular', sans-serif;
}

.placeholder-keyword {
  max-width: 90%;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.92);
  font-family: 'Aileron-Regular', sans-serif;
  word-break: break-word;

  .ratio-4-3 &,
  .ratio-3-2 & {
    color: #0f4c81;
  }

  .ratio-4-3 & + &,
  .ratio-3-2 & {
    color: #0f4c81;
  }
}

.ratio-4-3,
.ratio-3-2 {
  .placeholder-label {
    color: #5a7a96;
  }

  .placeholder-keyword {
    color: #0f4c81;
  }
}
</style>
